import { obterMarcasAsync } from "../../services/marcaService";

const atualizarMarcas = async ({ commit }) => {
    const marcas = await obterMarcasAsync();
    commit('atualizarMarcas', marcas);
}

const atualizarMarca = ({ commit }, marca) => {
    commit('atualizarMarca', marca);
}

const addMarca = ({ commit }, marca) => {
    commit('addMarca', marca);
}

const updateMarca = ({ commit }, marca) => {
    commit('updateMarca', marca);
}

export default {
    atualizarMarcas,
    atualizarMarca,
    addMarca,
    updateMarca
}
